import { useSeoMeta } from '@unhead/react';
import { DesktopEnvironment } from '@/desktop/DesktopEnvironment';

const Index = () => {
  useSeoMeta({
    title: 'nostrVM',
    description: 'A Nostr desktop environment in your browser.',
    ogTitle: 'nostrVM',
    ogDescription: 'A Nostr desktop environment in your browser.',
    ogImage: 'https://blossom.ditto.pub/eef381d2ad65a66420269bec93ee32576c069e03ec4a075d1bf1059d2b52de7d.jpeg',
    ogUrl: 'https://nostr-vm.shakespeare.to',
    twitterCard: 'summary_large_image',
    twitterTitle: 'nostrVM',
    twitterDescription: 'A Nostr desktop environment in your browser.',
    twitterImage: 'https://blossom.ditto.pub/eef381d2ad65a66420269bec93ee32576c069e03ec4a075d1bf1059d2b52de7d.jpeg',
  });

  return <DesktopEnvironment />;
};

export default Index;
